import PoliticasList from './List.jsx';

export default function PoliticasPage() {
  return <PoliticasList />;
}
